import Header from '../components/Header';
import Footer from '../components/Footer';

const FMALGoldCoast = () => {
}

export default FMALGoldCoast;